import React, { useEffect, useState } from 'react';
import {
  Divider, Form, Radio, Toast,
} from '@roo/roo';
import axx from 'axios';
import styled from 'styled-components';
import Editor from '@components/Editor';
import { getFileDownloadUrl, getS3Token } from '@assets/apis/base';
import { saveApplyInfo, getTemplateFileUrl } from '@assets/apis/scientist';
import { requiredRule } from '@utils/rules';
import { file_name_separator } from '@components/UploadPro';
import { genStr } from '@utils/utils';
import { useUserContext, useUserData } from '@components/UserData';
import { Recommend } from './recommend';
import { FormHok } from '../../_components/FormHok';
import { useSimpleContext } from '../../_context';
import { cols } from '../../_utils/config';
import { UploadField } from '../../_components/UploadField';

import './index.scss';

const Field = Form.Field;
const RadioGroup = Radio.ButtonGroup;
const RadioButton = RadioGroup.Button;
const axios = axx.create({ withCredentials: false });

const Root = styled.div`
    .form-patch {
        margin-top: 8px;
        width: 634px;
    }
    .form-group {
        & > label {
            text-align: left;
        }
    }
    .field-upload {
        margin-left: 12px;
    }
    .boffin {
        position: relative;
        .delete {
            position: absolute;
            top: -10px;
            right: 100px;
        }
    }
`;

// 因为url会拼接不同的 query 做校验
function getImageHost(url) {
  return url && url.split('?')[0];
}

function getDom(tagName, name, value) {
  const selectDom = [];
  const dom = document.getElementsByTagName(tagName);
  for (let i = 0; i < dom.length; i++) {
    const srcHost = dom[i].getAttribute(name).split('?')[0];
    const valueHost = value.split('?')[0];
    if (srcHost === valueHost) {
      selectDom.push(dom[i]);
    }
  }
  return selectDom;
}

const getImageList = (value, list = []) => {
  const matches = value.match(/<img src="(\S*)" width="(\S*)"/);
  const matchesV2 = value.match(/<img src="(\S*)">/);
  if (matches && matches[1] && matches[2]) {
    const key = matches[1];
    const width = matches[2];
    list.push({ key, width });
    return getImageList(value.replace(`<img src="${key}"`, ''), list);
  } else if (matchesV2 && matchesV2[1]) {
    const key = matchesV2[1];
    list.push({ key });
    return getImageList(value.replace(`<img src="${key}"`, ''), list);
  } else {
    return list;
  }
};

const setImageWidth = (value, mtUid, onlyWidth) => {
  const imgList = getImageList(value);
  imgList.forEach((item) => {
    const { key, width } = item;
    const imgNodeList = getDom('img', 'src', key);
    if (width) imgNodeList.map((imgNode) => imgNode.setAttribute('width', width));
    if (onlyWidth) return;
    const fileName = window.GreenFileKey[getImageHost(key)];
    if (!fileName) {
      return;
    }
    getFileDownloadUrl({ fileName, userId: mtUid, needWatermark: true }).then((res) => {
      imgNodeList.forEach((imgNode) => imgNode.setAttribute('src', res));
      window.GreenFileKey[getImageHost(res)] = fileName;
    });
  });
};

export const EditorField = ({
  onChange, disabled, value, tip, ...props
}) => {
  const { mtUid } = useUserData();
  const [token, setToken] = useState({});
  useEffect(() => {
    getS3Token().then((res) => {
      setToken(res);
    });
    if (value) {
      // 待元素注入编辑器后，调整图片宽度，以及图片链接替换
      setTimeout(() => setImageWidth(value, mtUid), 500);
    }
  }, []);

  function handleUpload(file, callback) {
    if (file.size > 10 * 1024 * 1024) {
      Toast.fail({
        title: '文件大小超过限制',
      });
      return false;
    }
    if (file.name.includes('@')) {
      Toast.fail({
        title: '标题包含特殊符号，上传失败',
      });
      return false;
    }
    // 拼接文件路径，使用分隔符将文件路径和名称进行分割
    const { policy, signature, awsaccessKeyId } = token;
    const formData = new FormData();
    const s3url = `https://mss.sankuai.com/${token.bucketName}`;
    const k = `${token.dir}${genStr()}${file_name_separator}${file.name}`.replace(/\s/g, '');
    const params = {
      policy, key: k, signature, awsaccessKeyId,
    };

    Object.entries(params).forEach(([k, v]) => {
      formData.append(k, v);
    });
    formData.append('file', file);
    axios
      .post(s3url, formData)
      .then((res) => {
        if (res.status === 200) {
          return getFileDownloadUrl({ fileName: k, userId: mtUid, needWatermark: true });
        } else {
          Toast.fail({ title: '上传失败' });
          return false;
        }
      })
      .then((res) => {
        if (res) {
          if (!window.fixEditorBug) {
            callback(res);
            window.fixEditorBug = true;
            setTimeout(() => {
              callback(res);
            }, 300);
          } else {
            callback(res);
          }
          // 设置 map，上传时提交保存
          if (!window.GreenFileKey) window.GreenFileKey = {};
          window.GreenFileKey[getImageHost(res)] = k;
        }
      });
  }
  return (
    <div className={disabled ? 'editor-disabled editor' : 'editor'}>
      <p className="editor-tip">{tip}</p>
      <Editor
        value={value}
        onChange={(value, delta, editor) => {
          if (Array.isArray(delta.ops)) {
            const [_, insertInfo] = delta.ops;
            if (insertInfo && insertInfo.insert && insertInfo.insert.image) {
              setImageWidth(value, mtUid);
            }
          }
          onChange(value);
        }}
        uploadImage={handleUpload}
        readOnly={disabled}
        {...props}
      />
    </div>
  );
};

// 附加信息
const ApplyInfo = function () {
  const { state } = useSimpleContext((t) => [t.innovate.iniValues, t.disabled]);
  const {
    state: { qingshan_apply_file },
  } = useUserContext((t) => [t.qingshan_apply_file]);
  return (
    <FormHok value={state.scientist.iniValues?.applyInfo} cols={cols} disabled={state.disabled} alwaysUpdate={false} handleSave={saveApplyInfo}>
      {(props) => (
        <Root className="boffin">
          <div className="form-title">
            推荐信息
            <Divider />
          </div>
          <Recommend {...props} />
          <div className="form-title">
            个人科研成就、进展及规划
            <Divider />
          </div>
          <div className="form-patch">
            <Field
              // label='温馨提示'
              layout="vertical"
              name="researchOverview.fillInType"
            >
              {({ value, handleChange }) => {
                const { setFieldValue, disabled } = props;
                return (
                  <RadioGroup
                    disabled={disabled}
                    value={value}
                    onChange={(v) => {
                      setFieldValue('researchOverview.fillInType', v);
                    }}
                  >
                    <RadioButton value="onlineFillIn">在线填写</RadioButton>
                    <RadioButton value="uploadFile">上传附件</RadioButton>
                  </RadioGroup>
                );
              }}
            </Field>
            {state?.values?.researchOverview?.fillInType === 'onlineFillIn' ? (
              <>
                <Field label="温馨提示" layout="vertical">
                  <div>
                    <p>推荐您直接在网页中填写内容。</p>
                    <p>如果您的内容存在大量公式、图表，您也可以选择上传PDF形式的文件。</p>
                  </div>
                </Field>
                <Field
                  required
                  label="个人研究方向对相关议题研究的贡献和价值"
                  rule={requiredRule}
                  name="researchOverview.contribution"
                  layout="vertical"
                  as={<EditorField className="apply-area" maxLength={500} tip="建议申报人评估研究工作面向青山科技奖哪个议题（绿色低碳材料、碳捕集及资源化利用、新能源及储能、降碳减污协同控制），概括性描述工作对可持续发展的贡献，限500字。" />}
                />
                <Field
                  required
                  label="科研及学术成就介绍"
                  name="researchOverview.achievement"
                  rule={requiredRule}
                  layout="vertical"
                  as={(
                    <EditorField
                      className="apply-area"
                      maxLength={2000}
                      tip="建议填写申报人过往科研发现的科学现象及规律，发明的新技术、新研究方法等；简要介绍申报人科研学术成果、知识产权的学术、应用价值，经济、社会、环境效益等；说明申报人在上述代表性论文、专利、奖项等成果中的贡献排序，限2000字。"
                    />
                  )}
                />
                <Field
                  required
                  label="在研科研项目及学术进展"
                  rule={requiredRule}
                  name="researchOverview.progress"
                  layout="vertical"
                  as={(
                    <EditorField
                      className="apply-area"
                      maxLength={1000}
                      tip="建议填写正在解决的科学、技术问题，目前的科研工作进展，使用的研究方法、设备、技术、数据等；也可介绍个人拟发表论文和拟申请知识产权，及其学术、应用价值，已产生或潜在的经济、社会、环境效益等。应注意说明申报人团队与合作团队的分工，限1000字。"
                    />
                  )}
                />
                <Field
                  required
                  label="未来五年科研工作规划"
                  rule={requiredRule}
                  name="researchOverview.futurePlan"
                  layout="vertical"
                  as={<EditorField className="apply-area" maxLength={1500} tip="建议填写未来五年拟解决的科学、技术问题，拟开展的科研工作计划，及其潜在学术、应用价值，经济、社会、环境效益等，限1500字。" />}
                />
              </>
            ) : null}
            {state?.values?.researchOverview?.fillInType === 'uploadFile' ? (
              <>
                <Field
                  required
                  name="researchOverview.overviewFile"
                  layout="vertical"
                >
                  {(props) => (
                    <div>
                      <div style={{ width: '100%', margin: '16px 0', color: '#999' }}>
                        <div style={{ marginBottom: '16px' }}>
                          <span>第一步：</span>
                          <a
                            style={{ cursor: 'pointer', color: '#ff6a00' }}
                            target="_blank"
                            onClick={(e) => {
                              getTemplateFileUrl({ fileType: 'researchOverview' })
                                .then((url) => {
                                  window.open(url);
                                })
                                .catch((err) => { });
                            }}
                          >
                            {/* <img src={download} alt='' /> */}
                            下载模板
                          </a>
                        </div>
                        <span>第二步：在模板文件内填写完成之后，上传PDF文件。</span>
                      </div>
                      <UploadField
                        value={props.value}
                        handleChange={(fs) => {
                          props.handleChange(fs);
                        }}
                        maxFiles={1}
                        type="pdf"
                      />
                    </div>
                  )}
                </Field>
              </>
            ) : null}
          </div>
          <br />
        </Root>
      )}
    </FormHok>
  );
};

export default ApplyInfo;
